<template>
  <div class="login-container">
    <div>
      <!-- <img src="../../assets/logo.png" class="logo" /> -->
      <!-- <img src="../../assets/welcome.png" class="welcome" /> -->
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        auto-complete="on"
        label-position="left"
      >
        <div class="title-container">
          <div class="title">账号密码登录</div>
        </div>
        <el-form-item prop="username">
          <span class="svg-container">
            <svg-icon icon-class="user" />
          </span>
          <el-input
            ref="username"
            v-model="loginForm.username"
            placeholder="请输入手机号"
            name="username"
            type="text"
            tabindex="1"
            auto-complete="on"
          />
        </el-form-item>
        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon icon-class="password" />
          </span>
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="密码"
            name="password"
            tabindex="2"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon
              :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
            />
          </span>
        </el-form-item>
        <el-form-item prop="captcha">
          <el-input
            ref="captcha"
            v-model="loginForm.captcha"
            placeholder="输入验证码"
            name="captcha"
            type="text"
            tabindex="3"
            auto-complete="on"
          />
          <img
            @click="getUserCode"
            :src="`data:image/png;base64,${captchaImg}`"
            class="code-img"
          />
        </el-form-item>
        <el-button
          :loading="loading"
          type="primary"
          style="width:100%;margin-bottom:10px;"
          @click.native.prevent="handleLogin"
          >登录</el-button
        >
        <div style="text-align: right;">
          <el-link type="primary" @click="handlePwd">忘记密码</el-link>
        </div>
      </el-form>
    </div>
    <footer class="login-footer">
      <a
        class="text-color"
        href="https://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
      >蜀ICP备2024095544号</a>
    </footer>
  </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
import sysAddrApi from "@/api/sys/sysAddr";
import customerLevelApi from "@/api/sys/customerLevel";
import userApi from "@/api/sys/user";
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        captcha: "",
        uuid: ""
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入手机号" }
        ],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
        captcha: [{ required: true, trigger: "blur", message: "请输入验证码" }]
      },
      loading: false,
      passwordType: "password",
      redirect: undefined,
      captchaImg: ""
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  mounted() {
    this.getUserCode();
  },
  methods: {
    handlePwd() {
      this.$router.push({ path: "/password" });
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      console.log("Login button clicked, form data:", this.loginForm);
      this.$refs.loginForm.validate(valid => {
        console.log("Form validation result:", valid);
        if (valid) {
          console.log("Form is valid, starting login process...");
          this.loading = true;
          this.$store
            .dispatch("user/login", this.loginForm)
            .then(async () => {
              console.log("Login successful, getting user info...");
              // 先获取用户信息
              await this.$store.dispatch("user/getInfo");
              console.log("User info retrieved, getting permissions...");
              
              // 获取用户权限 - 添加错误处理
              try {
                await this.$store.dispatch("user/getPermissions");
                console.log("Permissions retrieved successfully");
              } catch (error) {
                console.error("获取权限失败，但继续登录流程:", error);
                // 权限获取失败不影响登录，设置空权限数组
                this.$store.commit("user/SET_PERMISSIONS", []);
              }
              
              try {
                const res1 = await customerLevelApi.fetchList();
                localStorage.setItem(
                  "levelList",
                  JSON.stringify(res1.data || [])
                );
              } catch (error) {
                console.error("获取客户级别列表失败:", error);
                localStorage.setItem("levelList", JSON.stringify([]));
              }
              
              // this.$router.push({ path: this.redirect || '/' })
              this.$router.push({ path: "/" });
              this.loading = false;
              try {
                let res = await sysAddrApi.getAddressTreeList();
                localStorage.setItem(
                  "addressTree",
                  JSON.stringify(res.data || [])
                );
              } catch (error) {
                console.error("获取地址树列表失败:", error);
                localStorage.setItem("addressTree", JSON.stringify([]));
              }
            })
            .catch(error => {
              console.error("Login failed:", error);
              this.loading = false;
              // 显示具体的错误信息给用户
              if (error && error.message) {
                this.$message.error(error.message);
              } else if (typeof error === 'string') {
                this.$message.error(error);
              } else {
                this.$message.error('登录失败，请检查用户名、密码和验证码');
              }
            });
        } else {
          console.log("Form validation failed!");
          return false;
        }
      });
    },
    async getUserCode() {
      try {
        let res = await userApi.getCaptcha();
        let { img, uuid } = res.data;
        this.captchaImg = img;
        this.loginForm.uuid = uuid;
      } catch (error) {
        console.error("获取验证码", error);
      }
    }
  }
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: #666666;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #666666;
      height: 47px;
      caret-color: #000;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    // border: 1px solid rgba(255, 255, 255, 0.1);
    background: #f8f8f8;
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  position: relative;
  min-height: 100%;
  width: 100%;
  background: url("../../assets/bg.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  .login-footer {
    position: absolute;
    right: 0;
    bottom: 16px;
    left: 0;
    padding: 0 16px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;

    .text-color {
      color: #1677ff;

      &:hover,
      &:focus-visible {
        text-decoration: underline;
      }
    }
  }
  .login-box {
    width: 1200px;
    height: 500px;
    background: #164a7c80;
    position: absolute;
    left: calc(50% - 600px);
    top: 50%;
    transform: translateY(-50%);
    .logo {
      width: 150px;
      height: 100px;
      position: absolute;
      top: -150px;
      left: 0;
    }
    .welcome {
      width: 294px;
      height: 220px;
      position: absolute;
      left: 129px;
      top: 90px;
    }
  }
  .login-form {
    position: absolute;
    width: 452px;
    max-width: 100%;
    padding: 35px;
    margin: 0 auto;
    overflow: hidden;
    background: #fff;
    border-radius: 2px;
    right: 24%;
    top: 20%;
    // top: 50%;
    // transform: translateY(-50%);
    // left: calc(50% - 260px);
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 24px;
      // color: $light_gray;
      margin: 0px auto 40px auto;
      // text-align: center;
      // font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
@media (max-height: 600px) {
  .login-container {
    min-height: 600px;
  }
}
::v-deep .el-button--primary {
  background: #164a7c;
}
.code-img {
  width: 130px;
  height: 40px;
  position: absolute;
  right: 0;
  top: 3px;
  cursor: pointer;
}
</style>
